import React, { Suspense } from "react";
import { IPerson } from "../../models/IPerson";
import CompanyName from "../companies/CompanyName";
import { Icon, Popup, Segment } from "semantic-ui-react";
import { PersonPopupContent } from "./PersonPopupContent";
import { RenderCompany } from "../companies/RenderCompany";
import { usePerson } from "../../data/persons/usePerson";
import { ICompany } from "../../models/ICompany";
import "./_PersonName.less";


export interface PersonNameProps {
    as?: any;
    person: IPerson;
    company?: ICompany | null;

    showCompany?: boolean;
    showPhone?: boolean;
    showPhoneIcon?: boolean
    showEmailIcon?: boolean;
    infoPopup?: boolean;
    statusIcon?: JSX.Element

};

const PersonName: React.FC<PersonNameProps> = ({
    as: CustomWrapper,
    person,
    company,

    showCompany = false,
    showPhone = false,
    showPhoneIcon,
    showEmailIcon = false,
    infoPopup = false,

    statusIcon
}) => {

    const Wrapper = CustomWrapper || "span";

    return (
        <Wrapper className="PersonName_wrapper" title={person.fullname}>
            {statusIcon}
            <span className="PersonName_fullname notranslate">
                {infoPopup ? (
                    <Popup
                        on={["click"]}
                        position="top left"
                        trigger={<span style={{ cursor: "pointer" }}>{person.fullname}</span>}
                        content={(
                            <Suspense fallback={<Segment basic loading />}>
                                <PersonPopupContent person={person} company={company || null} />
                            </Suspense>
                        )}
                    />
                ) : person.fullname}
            </span>

            {showPhone && person.phone ? (
                <span className="PersonName_phone">
                    {(typeof showPhoneIcon === "undefined" || showPhoneIcon) && < Icon name="phone" />}{" "}
                    {person.phone}
                </span>
            ) : showPhoneIcon && person.phone ? (
                <span className="PersonName_phone">
                    <Icon name="phone" />{" "}
                </span>
            ) : null}

            {showEmailIcon && person.email ? (
                <span className="PersonName_phone">
                    <Icon name="mail" />{" "}
                </span>
            ) : null}

            {showCompany && company && (
                <CompanyName
                    className="PersonName_company notranslate"
                    company={company}
                    icon
                />
            )}
        </Wrapper>
    );
};

interface PersonNameByIdProps extends Omit<PersonNameProps, "person"> {
    personId: IPerson["id"];

}
export const PersonNameById: React.FC<PersonNameByIdProps> = ({ personId, ...props }) => {
    const { data: person } = usePerson(personId);

    if (!person) {
        return <div className="PersonNameById-loading" />
    };

    const componentProps = { ...props, person }

    if (person.company) {
        return (
            <RenderCompany
                companyId={person.company}
                render={({ company }) => (
                    <PersonName {...componentProps} company={company} />
                )}
            />
        )
    };

    return (
        <PersonName {...componentProps} />
    );
};


export default PersonName;
